<template>
  <div class="submit-button__container white-back-container">
    <div class="white-back-container__content">
      <div
        v-if="isAlcoholItem"
        id="submit-button__container__over-twenty"
        class="submit-button__container__over-twenty"
      >
        <div
          v-if="showableOverTwentyCheckErrorMessage"
          class="error-message submit-button__container__over-twenty__error-message"
        >
          {{ overTwentyCheckErrorMessage }}
        </div>
        <label
          class="submit-button__container__over-twenty-check__label"
          for="delivery_address_form_over_twenty_check"
        >
          <div
            class="submit-button__container__over-twenty__checkbox"
            :class="{
              checkbox: !isOverTwentyChecked,
              'checkbox--checked': isOverTwentyChecked
            }"
          >
            <input
              id="delivery_address_form_over_twenty_check"
              v-model="inputIsOverTwenty"
              type="checkbox"
              name="delivery_address_form[over_twenty_check]"
              :class="{
                field_with_errors: showableOverTwentyCheckErrorMessage
              }"
            />
            あなたは20歳以上ですか？
          </div>
        </label>
        <p
          class="submit-button__container__over-twenty__checkbox__minimal-info"
        >
          アルコール類の受け取りには、年齢制限があります
        </p>
      </div>
      <div class="submit-button__container__privacy-policy">
        <div
          v-if="showableAgreedPrivacyPolicyErrorMessage"
          class="error-message submit-button__container__privacy-policy__error-message"
        >
          個人情報の取扱いについての同意が必要です
        </div>
        <label
          class="submit-button__container__privacy-policy__label"
          for="delivery_address_form_agreed_privacy_policy"
        >
          <div
            class="submit-button__container__privacy-policy__checkbox"
            :class="{
              checkbox: !isAgreedPrivacyPolicyChecked,
              'checkbox--checked': isAgreedPrivacyPolicyChecked
            }"
          >
            <input
              id="delivery_address_form_agreed_privacy_policy"
              v-model="inputIsAgreedPrivacyPolicy"
              type="checkbox"
              name="delivery_address_form[agreed_privacy_policy]"
              :class="{
                field_with_errors: showableAgreedPrivacyPolicyErrorMessage
              }"
            />
            <a
              target="_blank"
              rel="noopener noreferrer"
              :href="privacyPolicyUrl"
              class="submit-button__container__privacy-policy__link"
            >
              個人情報の取扱いについて
            </a>
            に同意する
          </div>
        </label>
      </div>
      <div class="submit-button__container__button">
        <button
          :disabled="!isSubmittable || null"
          type="submit"
          class="btn btn--primary"
        >
          入力内容の確認
        </button>
      </div>
      <div class="minimal submit-minimal-info">
        お客様の情報はSSL暗号化通信によりセキュアに守られております
      </div>
    </div>
  </div>
</template>
<script>
import { PRIVACY_POLICY_URL } from '../../../../../constants/externalLinkConstants'

export default {
  props: {
    isAgreedPrivacyPolicy: {
      type: Boolean,
      required: true
    },
    isOverTwenty: {
      type: Boolean,
      required: true
    },
    isAlcoholItem: {
      type: Boolean,
      required: false
    },
    overTwentyCheckErrorMessage: {
      type: String,
      required: true
    },
    showableAgreedPrivacyPolicyErrorMessage: {
      type: Boolean,
      required: true
    },
    isSubmittable: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      privacyPolicyUrl: PRIVACY_POLICY_URL,
      isAgreedPrivacyPolicyChecked: false,
      isOverTwentyChecked: false
    }
  },
  computed: {
    showableOverTwentyCheckErrorMessage() {
      return this.overTwentyCheckErrorMessage.length !== 0
    },
    inputIsAgreedPrivacyPolicy: {
      get() {
        return this.$props.isAgreedPrivacyPolicy
      },
      set(value) {
        this.$emit('change-is-agreed-privacy-policy', value)
        this.isAgreedPrivacyPolicyChecked = value
      }
    },
    inputIsOverTwenty: {
      get() {
        return this.$props.isOverTwenty
      },
      set(value) {
        this.$emit('change-is-over-twenty', value)
        this.isOverTwentyChecked = value
      }
    }
  },
  mounted() {
    this.isAgreedPrivacyPolicyChecked = this.isAgreedPrivacyPolicy
    this.isOverTwentyChecked = this.isOverTwenty
  }
}
</script>
